import { ICollection } from '_/types/collections/collections.types';
import React, { ChangeEvent, Fragment } from 'react';

import FlowDefinition from '../FlowDefinition';

interface FlowState {
  name: string;
  collectionId: string;
  [key: string]: any;
}

interface LegacyExtractorFlowProps {
  collections: ICollection[];
  flow: FlowState;
  handleFieldChange: (
    event: ChangeEvent<HTMLInputElement> | { target: { name: string; value?: any; checked?: boolean; type?: string } },
  ) => void;
  isEditMode: boolean;
  orgSlug: string;
  projectSlug: string;
}

function LegacyExtractorFlow({
  collections,
  flow,
  handleFieldChange,
  isEditMode,
  orgSlug,
  projectSlug,
}: LegacyExtractorFlowProps) {
  return (
    <Fragment>
      <FlowDefinition
        collections={collections}
        flow={flow}
        handleFieldChange={handleFieldChange}
        isEditMode={isEditMode}
        orgSlug={orgSlug}
        projectSlug={projectSlug}
      />
    </Fragment>
  );
}

export default LegacyExtractorFlow;
